var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-group info-icon"},[_vm._v("  "),_c('span',{on:{"click":function($event){return _vm.notify()}}},[_c('svg-icon',{attrs:{"type":"mdi","path":_vm.icons.info}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }